import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowPopup } from "./arrowPopup";
import { SkinInput } from "./skinInput";
import * as S from "./skinPopup.styles";
export function SkinPopup({ selection, onChange, }) {
    return (_jsx(ArrowPopup, { children: _jsx(S.Wrapper, { children: _jsx(SkinInput, { onChange: onChange, selection: selection }) }) }));
}
